import type { ILoginInput } from "@services/api/authentication/login/interface";
import { httpClient } from "@services/api/httpClient";

const loginApi = (input: ILoginInput) => {
    return httpClient.post('/auth/login', input);
};

export default loginApi;